<template>
  <div v-if="iconName === 'index'">
    <svg
      :style="svgStyle"
      t="1764817009164"
      class="icon"
      viewBox="0 0 1072 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2856"
      width="200"
      height="200"
    >
      <path
        d="M671.548952 50.907429L955.245714 256a208.993524 208.993524 0 0 1 84.114286 201.142857L981.577143 832.853333a208.993524 208.993524 0 0 1-206.604191 177.200762H297.74019a208.993524 208.993524 0 0 1-206.60419-177.200762L33.987048 461.385143a208.993524 208.993524 0 0 1 89.234285-204.653714L431.737905 47.34781a208.993524 208.993524 0 0 1 239.811047 3.559619zM475.721143 112.152381L167.253333 321.584762a130.633143 130.633143 0 0 0-55.734857 127.951238l57.148953 371.46819a130.633143 130.633143 0 0 0 129.024 110.689524h477.379047a130.633143 130.633143 0 0 0 129.072762-110.738285l57.831619-375.661715a130.633143 130.633143 0 0 0-52.662857-125.756952L625.615238 114.44419A130.535619 130.535619 0 0 0 475.721143 112.152381z m112.883809 532.138667a52.224 52.224 0 1 1 0 104.496762H484.205714a52.224 52.224 0 0 1 0-104.496762h104.448z"
        p-id="2857"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'lag'">
    <svg
      :style="svgStyle"
      t="1764829226099"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="7433"
      width="200"
      height="200"
    >
      <path
        d="M544.597333 89.386667l30.293334 0.213333 28.629333 0.725333c9.301333 0.298667 18.346667 0.682667 27.178667 1.152l25.6 1.664c4.181333 0.341333 8.277333 0.64 12.330666 1.024l23.466667 2.432c136.661333 16.213333 197.845333 61.226667 220.032 150.058667a38.613333 38.613333 0 0 1-74.922667 18.688c-10.581333-42.24-36.864-69.034667-100.266666-83.882667l-15.36-3.2c-10.666667-2.005333-22.186667-3.754667-34.816-5.205333l-19.626667-2.005333-21.12-1.621334-22.784-1.28-24.448-0.853333-26.197333-0.512a2091.776 2091.776 0 0 0-13.738667-0.128h-27.306667l-25.685333 0.298667-24.405333 0.682666c-3.968 0.170667-7.850667 0.298667-11.733334 0.512l-22.570666 1.28c-11.008 0.682667-21.546667 1.578667-31.658667 2.645334l-19.626667 2.389333c-133.845333 18.432-186.112 73.728-202.069333 211.498667l-2.005333 20.224c-0.597333 6.954667-1.152 14.08-1.578667 21.418666l-1.152 22.613334-0.426667 11.690666-0.512 24.405334a1744.213333 1744.213333 0 0 0-0.128 12.714666v36.394667l0.512 33.365333 0.597334 20.906667 0.853333 19.925333 1.194667 18.901334 0.682666 9.088 1.621334 17.493333 0.981333 8.362667 2.218667 16.042666c15.616 101.546667 57.258667 146.218667 161.92 165.077334l16.597333 2.688 17.621333 2.304 18.688 1.962666 19.754667 1.621334 20.906667 1.322666 21.973333 1.066667 23.210667 0.768 37.077333 0.725333 36.522667 0.213334c0.085333-38.997333 8.533333-81.664 25.429333-103.082667l179.2-222.421333c44.458667-54.869333 113.408-61.013333 161.92-21.76 48.469333 39.253333 56.746667 108.032 12.373333 162.858666l-178.688 221.738667c-33.152 41.813333-151.552 68.181333-181.248 40.192a24.96 24.96 0 0 1-0.170666-0.170667l-29.781334-0.128-27.136-0.384-26.069333-0.64-25.002667-0.896-12.117333-0.597333-23.466667-1.408-22.485333-1.706667-21.461333-2.048a917.333333 917.333333 0 0 1-10.368-1.194666l-20.053334-2.602667a692.992 692.992 0 0 1-19.072-3.029333l-18.176-3.413334c-136.021333-27.904-193.408-93.44-213.973333-231.978666l-2.474667-18.474667-2.090666-19.370667-1.706667-20.181333-1.322667-21.077333-1.024-21.973334-0.725333-22.912a1809.706667 1809.706667 0 0 1-0.213333-11.776L110.72 512l0.213333-27.221333 0.682667-26.112 0.554667-12.629334 1.408-24.448c0.853333-11.989333 1.877333-23.552 3.114666-34.730666l2.730667-21.888c25.088-177.92 108.288-250.709333 298.112-269.994667l23.296-2.048c11.946667-0.938667 24.192-1.664 36.906667-2.176l25.941333-0.853333 13.354667-0.298667 27.605333-0.213333z m344.277334 480.64c-15.786667-12.8-36.053333-10.965333-53.333334 10.368l-38.741333 47.872-139.818667 173.738666c-4.138667 5.248-8.32 25.514667-8.746666 49.92v8.405334l0.213333 7.722666 7.125333-1.194666 8.32-1.706667c23.893333-5.290667 42.88-13.653333 46.762667-18.56l179.157333-222.293333c17.237333-21.333333 14.805333-41.514667-0.938666-54.272zM661.333333 324.053333a38.613333 38.613333 0 0 1 4.864 76.928l-4.864 0.298667h-89.386666V661.333333a38.613333 38.613333 0 0 1-76.928 4.864l-0.298667-4.864V401.28H405.333333a38.613333 38.613333 0 0 1-4.864-76.928l4.864-0.298667h256z"
        p-id="7434"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'func'">
    <svg
      t="1774509138942"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="52376"
      width="200"
      height="200"
    >
      <path
        d="M154.404571 24.380952h715.190858C941.104762 24.380952 999.619048 82.895238 999.619048 154.404571v715.190858C999.619048 941.104762 941.104762 999.619048 869.595429 999.619048H154.404571C82.895238 999.619048 24.380952 941.104762 24.380952 869.595429V154.404571C24.380952 82.895238 82.895238 24.380952 154.404571 24.380952z"
        fill="#FA4E00"
        p-id="52377"
      ></path>
      <path
        d="M277.942857 580.266667c-31.207619 0-58.514286-27.306667-58.514286-58.514286 0-31.207619 27.306667-58.514286 58.514286-58.514286 31.207619 0 58.514286 27.306667 58.514286 58.514286 0 31.207619-27.306667 58.514286-58.514286 58.514286z m234.057143 0c-31.207619 0-58.514286-27.306667-58.514286-58.514286 0-31.207619 27.306667-58.514286 58.514286-58.514286 31.207619 0 58.514286 27.306667 58.514286 58.514286 0 31.207619-27.306667 58.514286-58.514286 58.514286z m234.057143 0c-31.207619 0-58.514286-27.306667-58.514286-58.514286 0-31.207619 27.306667-58.514286 58.514286-58.514286 31.207619 0 58.514286 27.306667 58.514286 58.514286 0 31.207619-27.306667 58.514286-58.514286 58.514286z"
        fill="#FFFFFF"
        p-id="52378"
      ></path>
    </svg>
  </div>

  <div v-else-if="iconName === 'editor'">
    <svg
      t="1765176326278"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="32381"
      width="200"
      height="200"
    >
      <path
        d="M507.894 253.894c19.944 54.036 88.324 79.383 152.773 56.59 64.35-22.794 100.309-85.18 80.267-139.215-20.041-54.035-88.42-79.383-152.772-56.589-64.35 22.891-100.31 85.18-80.268 139.214z m24.856 374.808c102.176-71.915-41.95 80.365-64.94 162.5-22.99 82.132 31.832 146.976 143.34 110.232a155.56 155.56 0 0 0 13.068-5.11c5.01-1.276 10.315-2.946 15.915-4.911 233.038-83.018 363.313-309.77 290.808-506.555-22.597-61.207-62.091-112.295-112.786-151.103 29.474 29.474 52.66 64.647 67.495 104.927 63.073 171.537-50.303 369.208-253.18 441.614-5.206 1.867-10.217 4.029-14.932 6.288-11.692 2.062-21.32 2.85-27.607 1.965-38.315-5.403 132.927-179.79 128.506-266.344-4.52-86.555-118.682-78.794-206.512-37.824-87.635 40.968-240.015 69.558-161.811 156.309 69.85 77.515 182.636-11.988 182.636-11.988zM86.813 685.587c42.147 114.26 143.44 193.347 266.64 223.117-77.024-36.842-137.642-97.755-167.018-177.432-54.624-147.664 15.424-313.797 159.847-411.355 21.515-8.45 36.646-29.277 36.646-53.544 0-31.832-26.232-57.67-58.456-57.67-11.986 0-23.088 3.537-32.323 9.628C114.126 320.603 23.739 514.443 86.813 685.587z"
        p-id="32382"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'file'">
    <svg
      t="1765181476318"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="48122"
      width="200"
      height="200"
    >
      <path
        d="M381.633 132a90.045 90.045 0 0 1 60.34 23.206l120.801 109.059A30.015 30.015 0 0 0 582.887 272h191.338c49.721 0 90.029 40.294 90.029 90l-0.001 99.999 5.718 0.001C919.693 462 960 502.294 960 552a89.976 89.976 0 0 1-7.79 36.62l-111.392 250C826.352 871.085 794.13 892 758.578 892l-296.362-0.001V892H154.03C104.307 892 64 851.706 64 802V222c0-49.706 40.307-90 90.029-90h227.604zM869.97 522H297.702a30.01 30.01 0 0 0-27.413 17.793l-111.392 250A29.992 29.992 0 0 0 156.3 802c0 16.569 13.436 30 30.01 30h572.269a30.01 30.01 0 0 0 27.413-17.793l111.392-250c1.712-3.842 2.597-8.001 2.597-12.207 0-16.569-13.436-30-30.01-30zM381.633 192H154.029c-16.574 0-30.01 13.431-30.01 30v498.607l91.444-205.227c14.466-32.465 46.688-53.38 82.24-53.38l506.531-0.001V362c0-16.569-13.435-30-30.009-30H582.887a90.045 90.045 0 0 1-60.34-23.206L401.747 199.735A30.015 30.015 0 0 0 381.633 192z"
        p-id="48123"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'copy'">
    <svg
      t="1766025342347"
      class="icon"
      viewBox="0 0 1025 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="8094"
      width="200"
      height="200"
    >
      <path
        d="M688.7 1023.3H142.2c-76.2 0-138.1-62-138.1-138.1V338.7c0-76.2 62-138.1 138.1-138.1h546.5c76.2 0 138.1 62 138.1 138.1v546.5c0 76.1-62 138.1-138.1 138.1zM142.2 276.6c-34.3 0-62.1 27.9-62.1 62.1v546.5c0 34.3 27.9 62.1 62.1 62.1h546.5c34.3 0 62.1-27.9 62.1-62.1V338.7c0-34.3-27.9-62.1-62.1-62.1H142.2z"
        fill="#999999"
        p-id="8095"
      ></path>
      <path
        d="M987.8 447.8c-21 0-38-17-38-38V141.7c0-34.3-27.9-62.1-62.1-62.1H614.1c-21 0-38-17-38-38s17-38 38-38h273.6c76.2 0 138.1 62 138.1 138.1v268.1c0 21-17 38-38 38z"
        p-id="8096"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'editor-language'">
    <svg
      t="1766025775552"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="15730"
      width="200"
      height="200"
    >
      <path
        d="M503.8 520.2c18.6 18.6 48.8 18.6 67.5 0l415-415c18.6-18.6 18.6-48.8 0-67.5s-48.8-18.6-67.5 0l-415 415c-18.7 18.7-18.7 48.9 0 67.5z"
        p-id="15731"
      ></path>
      <path
        d="M976.3 370.4c-26.4 0-47.7 21.4-47.7 47.7v258.7c0 139-112.7 251.8-251.8 251.8H347.2c-139 0-251.8-112.7-251.8-251.8V347.2c0-139 112.7-251.8 251.8-251.8h206.1c26.4 0 47.7-21.4 47.7-47.7S579.6 0 553.3 0H343.8C153.9 0 0 153.9 0 343.8v336.4C0 870.1 153.9 1024 343.8 1024h336.4c189.9 0 343.8-153.9 343.8-343.8V418.1c0-26.3-21.4-47.7-47.7-47.7z"
        p-id="15732"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'collect'">
    <svg
      t="1766026163333"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="18370"
      width="200"
      height="200"
    >
      <path
        d="M752.165872 939.39509c-10.357905 0-20.766976-2.583848-30.15581-7.470135L514.397606 828.65494 304.962643 932.152129c-20.253276 10.809183-48.247864 8.91402-67.816548-5.51869-19.74674-14.204513-29.930683-39.446407-25.832342-64.055898l43.181475-224.130663L89.783863 484.698191c-18.092054-17.828041-24.520463-44.276413-16.841573-67.795059 7.452739-23.687492 27.481911-40.937364 52.176336-44.675502l228.604558-41.915645 102.468766-208.436216c11.150968-22.596647 33.511231-36.625152 58.262962-36.625152 24.63405 0 47.51006 14.432711 58.205657 36.801161l102.412484 208.144574 229.233891 40.709167c24.121374 3.619434 44.149523 20.754696 51.716872 44.676525 7.621585 23.397896 1.193175 49.851385-16.386202 67.156516L774.411525 638.446877l41.763173 223.728504c4.267187 24.842805-5.92085 50.083675-26.001187 64.687278C779.304975 934.854681 765.704213 939.39509 752.165872 939.39509L752.165872 939.39509zM514.454912 777.421069 742.494605 890.811582c7.452739 3.965312 15.019065 3.104711 20.934798-1.207501 6.090718-4.487198 9.159614-11.962449 7.910157-19.261693l-46.369074-248.28069 183.203532-172.669618c4.836145-4.7727 6.77224-12.594853 4.492314-19.609617-2.330068-7.299243-8.303106-12.419867-15.755846-13.510712l-252.392334-44.732807L531.75288 142.345985c-6.54609-13.625322-28.107151-13.568017-34.822087 0.061398L384.334365 371.425358l-251.763001 46.227858c-8.082072 1.207501-14.055111 6.383384-16.272615 13.511735-2.39249 7.184633-0.400113 15.006785 4.835122 20.239973l182.865841 170.713057-47.90915 248.741177c-1.137916 6.838755 1.87879 14.371312 7.740288 18.626219 6.203282 4.600785 14.223956 5.118578 20.652366 1.671059L514.454912 777.421069 514.454912 777.421069zM514.454912 777.421069"
        p-id="18371"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'languageTitle'">
    <svg
      t="1766027313573"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="36519"
      width="200"
      height="200"
    >
      <path
        d="M840.533333 260.266667c-38.4-8.533333-68.266667-38.4-72.533333-76.8-4.266667-17.066667-25.6-17.066667-29.866667 0-8.533333 38.4-38.4 68.266667-72.533333 76.8-17.066667 4.266667-17.066667 29.866667 0 29.866666 38.4 8.533333 68.266667 38.4 72.533333 76.8 0 17.066667 25.6 17.066667 29.866667 0 8.533333-38.4 38.4-68.266667 72.533333-76.8 17.066667-4.266667 17.066667-25.6 0-29.866666zM750.933333 422.4c-17.066667 0-34.133333 12.8-34.133333 34.133333v285.866667c0 46.933333-38.4 85.333333-85.333333 85.333333H285.866667c-46.933333 0-85.333333-38.4-85.333334-85.333333V392.533333c0-46.933333 38.4-85.333333 85.333334-85.333333h294.4c17.066667 0 34.133333-12.8 34.133333-34.133333s-17.066667-29.866667-34.133333-29.866667H285.866667c-81.066667 0-149.333333 68.266667-149.333334 149.333333v345.6c0 81.066667 68.266667 149.333333 149.333334 149.333334h349.866666c81.066667 0 149.333333-68.266667 149.333334-149.333334v-285.866666c0-17.066667-17.066667-29.866667-34.133334-29.866667z"
        p-id="36520"
      ></path>
      <path
        d="M460.8 699.733333c17.066667 0 34.133333-12.8 34.133333-34.133333v-174.933333h89.6c17.066667 0 34.133333-12.8 34.133334-34.133334s-17.066667-29.866667-34.133334-29.866666H337.066667c-17.066667 0-34.133333 12.8-34.133334 34.133333s12.8 34.133333 34.133334 34.133333H426.666667v174.933334c0 17.066667 17.066667 29.866667 34.133333 29.866666z"
        p-id="36521"
      ></path>
    </svg>
  </div>

  <div v-else-if="iconName === 'clip'">
    <svg
      t="1766385306120"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="10139"
      width="200"
      height="200"
    >
      <path
        d="M223.168 64a160 160 0 0 0-160 161.088L64 351.296V800A160 160 0 0 0 224 960h576a160 160 0 0 0 160-160V351.744l-0.832-128.832A160 160 0 0 0 799.168 64h-576z m-96 160.64A96 96 0 0 1 223.168 128H300.16l-96 192H127.808l-0.64-95.36zM275.776 320l96-192h184.448l-96 192H275.84z m256 0l96-192h171.392c4.288 0 8.512 0.256 12.608 0.832L716.224 320H531.84z m364.032 0h-108.032l81.024-162.048c16.192 17.024 26.176 40.064 26.368 65.408l0.64 96.64zM128 800V384h768v416a96 96 0 0 1-96 96h-576A96 96 0 0 1 128 800z m346.496-310.848A64 64 0 0 0 384 547.392v121.216a64 64 0 0 0 90.496 58.24l133.312-60.608c50.048-22.72 50.048-93.76 0-116.48l-133.312-60.608z"
        p-id="10140"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'map'">
    <svg
      t="1767682143015"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="6858"
      width="200"
      height="200"
    >
      <path
        d="M512 800.182857a18.651429 18.651429 0 0 1-12.8-5.485714c-10.971429-10.971429-261.485714-265.508571-261.485714-428.982857A271.725714 271.725714 0 0 1 512 91.428571a271.725714 271.725714 0 0 1 274.285714 274.285715c0 163.474286-250.514286 418.011429-261.485714 428.982857a18.651429 18.651429 0 0 1-12.8 5.485714zM512 128A235.154286 235.154286 0 0 0 274.285714 365.714286c0 128.731429 186.148571 334.994286 237.714286 389.485714 51.565714-54.491429 237.714286-260.754286 237.714286-389.485714A235.154286 235.154286 0 0 0 512 128z"
        fill=""
        p-id="6859"
      ></path>
      <path
        d="M512 457.142857a91.428571 91.428571 0 1 1 91.428571-91.428571 91.428571 91.428571 0 0 1-91.428571 91.428571z m0-146.285714a54.857143 54.857143 0 1 0 54.857143 54.857143A54.857143 54.857143 0 0 0 512 310.857143zM512 932.571429c-208.822857 0-420.571429-43.885714-420.571429-128 0-65.097143 123.977143-96.914286 197.851429-109.714286a18.651429 18.651429 0 0 1 21.211429 14.994286 18.285714 18.285714 0 0 1-14.628572 21.211428c-123.245714 21.942857-167.862857 55.954286-167.862857 73.142857 0 36.571429 149.577143 91.428571 384 91.428572S896 841.142857 896 804.571429c0-17.92-44.617143-51.931429-167.862857-73.142858a18.285714 18.285714 0 0 1-14.628572-21.211428 18.651429 18.651429 0 0 1 21.211429-14.994286c73.142857 13.165714 197.851429 44.982857 197.851429 109.714286 0 83.748571-211.748571 127.634286-420.571429 127.634286z"
        p-id="6860"
      ></path>
    </svg>
  </div>

  <div v-else-if="iconName === 'ppt'">
    <svg
      t="1773988990137"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3326"
      width="200"
      height="200"
    >
      <path
        d="M219.424 18.304h530.272l201.152 219.424v768H219.424V18.304z"
        fill="#FFFFFF"
        p-id="3327"
      ></path>
      <path
        d="M733.696 253.728V50.304H251.424v923.424h667.424v-720h-185.152z m217.152-16v768H219.424V18.304h530.272l201.152 219.424z m-58.08-16l-127.04-138.624v138.624h127.04z"
        fill="#465F78"
        p-id="3328"
      ></path>
      <path
        d="M64 256m32 0l448 0q32 0 32 32l0 448q0 32-32 32l-448 0q-32 0-32-32l0-448q0-32 32-32Z"
        fill="#FF501A"
        p-id="3329"
      ></path>
      <path
        d="M640 416h224v37.344h-224V416zM640 509.344h224v37.312h-224v-37.312zM640 602.656h224V640h-224v-37.344z"
        fill="#FF501A"
        p-id="3330"
      ></path>
      <path
        d="M224 658.88V384h89.056c33.76 0 55.744 1.376 66.016 4.128 15.744 4.128 28.928 13.12 39.552 27.008 10.624 13.76 15.936 31.552 15.936 53.44 0 16.864-3.072 31.04-9.184 42.56-6.112 11.488-13.952 20.544-23.424 27.2a80.352 80.352 0 0 1-28.704 12.928c-13.248 2.624-32.448 3.936-57.568 3.936h-36.16v103.68H224z m55.488-228.384v78.016h30.4c21.856 0 36.48-1.44 43.84-4.32a36.576 36.576 0 0 0 23.616-34.88c0.032-10.016-2.88-18.24-8.768-24.736a38.4 38.4 0 0 0-22.336-12.192c-6.624-1.28-19.936-1.888-39.936-1.888h-26.816z"
        fill="#FFFFFF"
        p-id="3331"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'word'">
    <svg
      t="1773989097786"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3484"
      width="200"
      height="200"
    >
      <path
        d="M219.424 18.304h530.272l201.152 219.424v768H219.424V18.304z"
        fill="#FFFFFF"
        p-id="3485"
      ></path>
      <path
        d="M733.696 253.728V50.304H251.424v923.424h667.424v-720h-185.152z m217.152-16v768H219.424V18.304h530.272l201.152 219.424z m-58.08-16l-127.04-138.624v138.624h127.04z"
        fill="#465F78"
        p-id="3486"
      ></path>
      <path
        d="M73.152 288a32 32 0 0 1 32-32h448a32 32 0 0 1 32 32v448a32 32 0 0 1-32 32h-448a32 32 0 0 1-32-32V288zM640 416h224v37.344h-224V416zM640 509.344h224v37.312h-224v-37.312zM640 602.656h224V640h-224v-37.344z"
        fill="#317BFF"
        p-id="3487"
      ></path>
      <path
        d="M221.952 640l-56.256-235.616H214.4l35.52 161.856 43.072-161.856h56.576l41.28 164.576 36.16-164.576h47.904L417.696 640h-50.464l-46.912-176.16L273.536 640H221.952z"
        fill="#FFFFFF"
        p-id="3488"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'xlsx'">
    <svg
      t="1773989162983"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3641"
      width="200"
      height="200"
    >
      <path
        d="M219.424 18.304h530.272l201.152 219.424v768H219.424V18.304z"
        fill="#FFFFFF"
        p-id="3642"
      ></path>
      <path
        d="M733.696 253.728V50.304H251.424v923.424h667.424v-720h-185.152z m217.152-16v768H219.424V18.304h530.272l201.152 219.424z m-58.08-16l-127.04-138.624v138.624h127.04z"
        fill="#465F78"
        p-id="3643"
      ></path>
      <path
        d="M64 288a32 32 0 0 1 32-32h448a32 32 0 0 1 32 32v448a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288zM640 416h224v37.344h-224V416zM640 509.344h224v37.312h-224v-37.312zM640 602.656h224V640h-224v-37.344z"
        fill="#47B347"
        p-id="3644"
      ></path>
      <path
        d="M192 658.88l93.952-143.456L200.832 384h64.864l55.104 88.32L374.816 384h64.32l-85.504 133.504 93.92 141.376h-66.912L319.68 563.84l-61.12 95.04H192z"
        fill="#FFFFFF"
        p-id="3645"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'pdf'">
    <svg
      t="1773989219002"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3798"
      width="200"
      height="200"
    >
      <path
        d="M219.424 18.304h530.272l201.152 219.424v768H219.424V18.304z"
        fill="#FFFFFF"
        p-id="3799"
      ></path>
      <path
        d="M733.696 253.728V50.304H251.424v923.424h667.424v-720h-185.152z m217.152-16v768H219.424V18.304h530.272l201.152 219.424z m-58.08-16l-127.04-138.624v138.624h127.04z"
        fill="#465F78"
        p-id="3800"
      ></path>
      <path
        d="M64 288a32 32 0 0 1 32-32h448a32 32 0 0 1 32 32v448a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288zM640 416h224v37.344h-224V416zM640 509.344h224v37.312h-224v-37.312zM640 602.656h224V640h-224v-37.344z"
        fill="#FF501A"
        p-id="3801"
      ></path>
      <path
        d="M505.92 556.992c-8.512-10.24-25.984-15.2-53.44-15.2-15.936 0-35.2 1.696-57.28 5.056-60.288-44.544-77.12-93.696-77.12-93.696s10.272-26.496 10.944-69.76c0.416-27.36-3.776-45.824-14.624-56.544A26.688 26.688 0 0 0 296.416 320a23.648 23.648 0 0 0-14.176 4.544c-31.36 23.168 2.88 132.448 3.776 135.36a981.76 981.76 0 0 1-52.608 110.016c-6.24 11.104-5.632 10.24-10.88 19.296 0 0-53.056 25.184-78.784 56.096-14.528 17.472-16.384 29.28-15.584 38.272v0.192c1.216 10.56 14.656 20.224 28.16 20.224 0.544 0 1.12 0 1.664-0.064 13.728-0.832 28.768-10.688 45.984-30.08 11.36-12.832 26.112-35.392 43.904-67.072 50.976-14.656 95.872-25.088 133.472-31.04 27.616 14.976 68.64 32 96.576 32 9.376 0 16.928-1.952 22.4-5.76 6.592-4.544 9.376-10.24 11.104-20.736 1.76-10.496-0.64-18.464-5.472-24.256z m-59.552 12.8c24.512 0 37.76 3.616 44.608 6.624 2.112 0.928 3.648 1.824 4.704 2.56-1.92 1.28-5.696 2.816-12.512 2.816-11.328 0-26.208-4-44.352-11.904l7.552-0.096z m-145.344-227.84l0.064-0.128c5.248 2.816 7.712 22.464 7.232 33.856-0.64 15.296-0.832 21.184-3.488 30.592-7.2-19.584-7.68-54.784-3.808-64.32z m1.92 155.008c12.384 20.32 30.72 42.304 48.384 57.984-34.464 7.36-67.584 16.608-88.192 23.776 22.08-38.08 38.4-77.984 39.808-81.76zM160.992 672c2.976-5.056 11.168-14.816 31.904-33.664-14.208 21.6-24.64 33.344-35.264 40.672 0.896-2.304 1.984-4.736 3.36-7.04z"
        fill="#FFFFFF"
        p-id="3802"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'plan'">
    <svg
      t="1773989966857"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3231"
      width="200"
      height="200"
    >
      <path
        d="M512 133.12a276.48 276.48 0 0 0-138.24 515.9936l15.36 8.8576V737.28h245.76v-79.3088l15.36-8.8576A276.48 276.48 0 0 0 512 133.12zM174.08 409.6a337.92 337.92 0 1 1 522.24 283.2896V798.72H327.68v-105.8304A337.664 337.664 0 0 1 174.08 409.6zM327.68 890.88h368.64v61.44H327.68v-61.44z"
        fill="#496189"
        p-id="3232"
      ></path>
      <path
        d="M728.1664 397.3632v24.576a188.4672 188.4672 0 0 1-121.7024 176.2816l-23.04 8.704-17.408-45.9776 23.04-8.704a139.3152 139.3152 0 0 0 89.9584-130.304v-24.576h49.152z"
        fill=""
        p-id="3233"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'paperwork'">
    <svg
      t="1774506737980"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="5815"
      width="200"
      height="200"
    >
      <path
        d="M0 0m204.8 0l614.4 0q204.8 0 204.8 204.8l0 614.4q0 204.8-204.8 204.8l-614.4 0q-204.8 0-204.8-204.8l0-614.4q0-204.8 204.8-204.8Z"
        fill="#54B5FF"
        p-id="5816"
      ></path>
      <path
        d="M458.615467 692.906667a196.130133 196.130133 0 0 1 196.164266-196.130134A196.164267 196.164267 0 0 1 850.944 692.906667a196.164267 196.164267 0 0 1-196.164267 196.164266 196.164267 196.164267 0 0 1-196.164266-196.164266z m196.164266 132.3008a132.3008 132.3008 0 0 0 132.3008-132.3008 132.334933 132.334933 0 0 0-116.053333-131.310934v140.6976h-148.0704a132.3008 132.3008 0 0 0 131.822933 123.0848z m-399.7696 23.893333c-58.197333 0-84.650667-16.827733-86.596266-70.075733V231.3216a97.860267 97.860267 0 0 1 64.6144-91.2384l4.266666-1.194667a33.757867 33.757867 0 0 1 8.3968-2.082133l4.608-0.273067h273.544534a57.787733 57.787733 0 0 1 38.570666 14.2336l1.672534 1.672534 202.888533 162.952533a60.177067 60.177067 0 0 1 17.339733 36.4544l0.273067 5.8368v84.718933a31.9488 31.9488 0 0 1-29.9008 31.8464 31.914667 31.914667 0 0 1-33.6896-27.8528l-0.273067-4.027733v-64.477867H576.853333a80.554667 80.554667 0 0 1-51.2-19.3536l-5.4272-4.8128-1.092266-1.1264a78.711467 78.711467 0 0 1-22.186667-55.842133v-96.3584h-240.981333c-9.864533 0-21.538133 14.0288-23.415467 27.306667l-0.3072 3.413333v541.252267l-0.170667 5.188266-0.375466 5.0176c0 1.9456 0.443733 2.730667 2.525866 2.9696h3.413334l8.772266-0.375466h158.685867a31.9488 31.9488 0 0 1 31.8464 29.934933 31.9488 31.9488 0 0 1-27.8528 33.6896l-4.027733 0.273067z m305.5616-604.945067v52.599467a17.237333 17.237333 0 0 0 2.218667 8.942933l1.4336 1.9456 0.6144 0.648534a18.6368 18.6368 0 0 0 11.810133 5.802666h69.973334l-86.050134-69.905066z m-248.832 441.9584a31.9488 31.9488 0 0 1-31.8464-29.934933 31.914667 31.914667 0 0 1 27.818667-33.6896l4.027733-0.273067h53.6576a31.914667 31.914667 0 0 1 31.8464 29.934934 31.9488 31.9488 0 0 1-27.8528 33.6896l-3.9936 0.273066z m0-178.414933a31.9488 31.9488 0 0 1-31.8464-29.934933 31.914667 31.914667 0 0 1 27.818667-33.6896l4.027733-0.273067H460.8a31.914667 31.914667 0 0 1 32.1536 29.934933 31.914667 31.914667 0 0 1-28.16 33.723734l-3.9936 0.273066z"
        fill="#FFFFFF"
        p-id="5817"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'audio'">
    <svg
      t="1774506870009"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="10746"
      width="200"
      height="200"
    >
      <path
        d="M170.6496 0h682.6496C947.5584 0 1024 76.3904 1024 170.6496v682.6496c0 94.2592-76.4416 170.7008-170.7008 170.7008H170.6496C76.3904 1024 0 947.5584 0 853.2992V170.6496C0 76.3904 76.3904 0 170.6496 0z m235.1104 354.4576v243.8144c-8.7552-3.1744-18.2784-4.9152-28.16-4.9152-43.8784 0-79.36 33.8432-79.36 75.52 0 41.728 35.4816 75.52 79.36 75.52 43.8272 0 79.3088-33.792 79.3088-75.52v-188.416l192.0512-30.3104v68.6592c-8.7552-3.4304-18.2784-5.3248-28.16-5.3248-43.8784 0-79.36 33.8432-79.36 75.52 0 41.728 35.4816 75.52 79.36 75.52 43.8272 0 79.3088-30.72 79.3088-72.448V320.1024a37.4784 37.4784 0 0 0-3.6352-16.384c-1.1776-2.4064-2.5088-4.6592-4.096-6.7584-1.6384-2.2016-3.584-4.1984-5.6832-6.0416-2.1504-1.8432-4.4544-3.3792-6.8608-4.6592-2.304-1.2288-4.7616-2.2528-7.3216-3.0208-2.6112-0.768-5.2736-1.2288-7.936-1.4336-2.9184-0.2048-5.8368-0.1024-8.8064 0.4096l-217.6512 34.3552c-4.6592 0.7168-8.9088 2.1504-12.7488 4.352-3.7888 2.1504-7.424 5.12-10.4448 8.6016-3.072 3.584-5.376 7.4752-6.912 11.6224-1.4848 4.1472-2.2528 8.6016-2.2528 13.312z m243.2 43.8272l-192.0512 30.3104V365.4144l192.0512-30.3104v63.1808z m-28.16 166.4c15.5136 0 28.16 13.9776 28.16 27.392 0 13.4656-12.6464 21.248-28.16 21.248-15.5648 0-28.2112-10.8544-28.2112-24.32 0-13.4144 12.6464-24.32 28.2112-24.32z m-215.04 104.192c0-13.4144-12.6464-24.32-28.16-24.32-15.5648 0-28.2112 10.9056-28.2112 24.32 0 13.4656 12.6464 24.32 28.2112 24.32 15.5136 0 28.16-10.8544 28.16-24.32z"
        fill="#9793FF"
        p-id="10747"
      ></path>
      <path
        d="M405.76 598.272V354.4576c0-4.7104 0.768-9.1648 2.2528-13.312 1.536-4.1472 3.84-8.0384 6.912-11.6224 3.0208-3.4816 6.656-6.4512 10.4448-8.6016 3.84-2.2016 8.0896-3.6352 12.7488-4.352l217.6512-34.3552c2.9696-0.512 5.888-0.6144 8.8064-0.4096 2.6624 0.2048 5.3248 0.6656 7.936 1.4336 2.56 0.768 5.0176 1.792 7.3216 3.0208 2.4064 1.28 4.7104 2.816 6.8608 4.6592 2.0992 1.8432 4.0448 3.84 5.6832 6.0416 1.5872 2.0992 2.9184 4.352 4.096 6.7584a37.4784 37.4784 0 0 1 3.6352 16.384v271.9744c0 41.728-35.4816 72.448-79.3088 72.448-43.8784 0-79.36-33.792-79.36-75.52 0-41.6768 35.4816-75.52 79.36-75.52 9.8816 0 19.4048 1.8944 28.16 5.3248V450.1504l-192.0512 30.3104v188.416c0 41.728-35.4816 75.52-79.3088 75.52-43.8784 0-79.36-33.792-79.36-75.52 0-41.6768 35.4816-75.52 79.36-75.52 9.8816 0 19.4048 1.7408 28.16 4.9152z m51.1488-169.6768l192.0512-30.3104V335.104l-192.0512 30.3104v63.1808z m192.0512 163.4816c0-13.4144-12.6464-27.392-28.16-27.392-15.5648 0-28.2112 10.9056-28.2112 24.32 0 13.4656 12.6464 24.32 28.2112 24.32 15.5136 0 28.16-7.7824 28.16-21.248z m-271.36 52.48c15.5136 0 28.16 10.9056 28.16 24.32 0 13.4656-12.6464 24.32-28.16 24.32-15.5648 0-28.2112-10.8544-28.2112-24.32 0-13.4144 12.6464-24.32 28.2112-24.32z"
        fill="#FFFFFF"
        p-id="10748"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'marker'">
    <svg
      t="1774507034989"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="24720"
      width="200"
      height="200"
    >
      <path
        d="M0 0m365.714286 0l292.571428 0q365.714286 0 365.714286 365.714286l0 292.571428q0 365.714286-365.714286 365.714286l-292.571428 0q-365.714286 0-365.714286-365.714286l0-292.571428q0-365.714286 365.714286-365.714286Z"
        fill="#FEC141"
        p-id="24721"
      ></path>
      <path
        d="M0 175.542857m365.714286 0l292.571428 0q365.714286 0 365.714286 365.714286l0 117.028571q0 365.714286-365.714286 365.714286l-292.571428 0q-365.714286 0-365.714286-365.714286l0-117.028571q0-365.714286 365.714286-365.714286Z"
        fill="#FEB830"
        p-id="24722"
      ></path>
      <path
        d="M0 351.085714m336.457143 0l351.085714 0q336.457143 0 336.457143 336.457143l0 0q0 336.457143-336.457143 336.457143l-351.085714 0q-336.457143 0-336.457143-336.457143l0 0q0-336.457143 336.457143-336.457143Z"
        fill="#FDAE1B"
        p-id="24723"
      ></path>
      <path
        d="M323.247543 277.942857c-14.628571 0-30.676114 11.6736-30.676114 26.112v430.518857C292.571429 748.968229 308.253257 760.685714 322.8672 760.685714c14.599314 0 30.690743-11.732114 30.690743-26.112v-430.518857c0-14.4384-15.696457-26.112-30.3104-26.112z m314.909257 35.84c-86.030629 0-86.030629-34.7136-172.075886-34.7136q-49.664 0-88.020114 22.805943l-0.351086 259.832686q38.7072-22.762057 88.3712-22.762057c86.045257 0 86.045257 34.698971 172.075886 34.698971q53.833143 0 107.900343-27.808914V286.017829q-54.0672 27.7504-107.900343 27.7504z"
        fill="#FFFFFF"
        p-id="24724"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'pdf-func'">
    <svg
      t="1774507099304"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="28835"
      width="200"
      height="200"
    >
      <path
        d="M157.538462 0h708.923076a157.538462 157.538462 0 0 1 157.538462 157.538462v708.923076a157.538462 157.538462 0 0 1-157.538462 157.538462H157.538462a157.538462 157.538462 0 0 1-157.538462-157.538462V157.538462a157.538462 157.538462 0 0 1 157.538462-157.538462z"
        fill="#FF5A55"
        p-id="28836"
      ></path>
      <path
        d="M816.974769 585.531077c-13.922462-16.738462-42.456615-24.792615-87.552-24.792615-26.190769 0-57.698462 3.012923-93.833846 8.388923-99.170462-73.373538-127.015385-153.777231-127.015385-153.777231s16.915692-43.559385 17.92-114.569846c0.649846-44.898462-6.301538-75.027692-23.886769-92.475077-6.971077-7.030154-18.569846-11.382154-29.518769-11.382154-8.625231 0-16.580923 2.678154-23.217231 7.364923-51.396923 37.533538 4.647385 217.088 6.301539 221.774769a1579.165538 1579.165538 0 0 1-86.212923 180.578462c-9.944615 18.097231-9.294769 16.738462-17.92 31.822769 0 0-86.862769 41.550769-129.319385 92.120615-23.867077 28.829538-26.860308 47.911385-25.540923 62.660923v0.33477c1.988923 17.408 23.886769 33.496615 46.099692 33.496615h2.993231c22.212923-1.339077 47.419077-17.427692 75.264-49.230769 18.569846-21.129846 42.791385-57.974154 72.290462-110.237539 83.889231-24.123077 157.184-41.196308 218.88-50.924307 45.430154 24.457846 112.403692 52.598154 158.503384 52.598154 15.596308 0 27.864615-3.347692 36.824616-9.708308 10.594462-7.364923 15.556923-16.738462 18.215384-34.166154 2.658462-17.427692-1.319385-30.148923-9.275077-39.876923z m-97.831384 21.110154c40.467692 0 62.030769 6.025846 72.96 10.712615l7.955692 4.017231c-3.308308 2.028308-9.609846 4.371692-20.558769 4.371692-18.569846 0-42.771692-6.695385-72.625231-19.436307 3.977846 0.334769 8.290462 0.334769 12.268308 0.334769zM480.708923 232.763077c8.96 4.352 12.603077 36.529231 11.953231 55.276308-0.984615 25.127385-1.339077 34.855385-5.651692 50.254769-11.618462-32.157538-12.603077-89.796923-6.301539-105.531077z m2.993231 254.621538c20.224 33.476923 50.412308 69.336615 79.261538 95.133539-56.713846 12.071385-110.769231 27.470769-144.600615 39.187692 36.489846-62.621538 63.350154-128.295385 65.339077-134.321231zM250.88 774.498462c4.982154-8.388923 18.254769-24.142769 52.401231-55.296-23.217231 35.170462-40.448 54.606769-58.033231 67.012923 1.654154-4.036923 3.643077-8.388923 5.632-11.736616z"
        fill="#FFFFFF"
        p-id="28837"
      ></path>
    </svg>
  </div>
  <div v-else-if="iconName === 'case'">
    <svg
      t="1774507283673"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="45150"
      width="200"
      height="200"
    >
      <path
        d="M273.066667 0h477.866666C933.790476 0 1024 90.209524 1024 273.066667v477.866666C1024 933.790476 933.790476 1024 750.933333 1024H273.066667C90.209524 1024 0 933.790476 0 750.933333V273.066667C0 90.209524 90.209524 0 273.066667 0z"
        fill="#2196F3"
        p-id="45151"
      ></path>
      <path
        d="M741.180952 658.285714c19.504762 19.504762 36.571429 34.133333 56.076191 56.076191-7.314286 4.87619-92.647619 92.647619-129.219048 129.219047-21.942857 21.942857-51.2 26.819048-80.457143 34.133334-9.752381 2.438095-12.190476-4.87619-9.752381-12.190476 7.314286-29.257143 14.628571-60.952381 39.009524-82.895239 43.885714-39.009524 82.895238-82.895238 124.342857-124.342857zM624.152381 199.92381c9.752381 4.87619 19.504762 4.87619 24.380952 12.190476 29.257143 26.819048 60.952381 53.638095 90.209524 80.457143 7.314286 7.314286 9.752381 21.942857 14.628572 34.133333h-102.4c-4.87619 0-12.190476-4.87619-14.628572-9.752381-4.87619-9.752381-9.752381-19.504762-9.752381-29.257143-2.438095-29.257143-2.438095-56.07619-2.438095-87.771428z"
        fill="#FFFFFF"
        p-id="45152"
      ></path>
      <path
        d="M824.07619 692.419048c-19.504762-19.504762-36.571429-39.009524-56.07619-58.514286 7.314286-7.314286 19.504762-21.942857 36.571429-19.504762 19.504762 4.87619 31.695238 19.504762 39.009523 39.009524 7.314286 17.066667-7.314286 29.257143-19.504762 39.009524z m-75.580952-307.2v-17.066667h-92.647619c-31.695238 0-53.638095-14.628571-65.828571-43.885714-4.87619-14.628571-7.314286-31.695238-9.752381-48.761905-2.438095-24.380952 0-51.2 0-78.019048H304.761905c-9.752381 0-21.942857 4.87619-29.257143 9.752381-31.695238 19.504762-48.761905 48.761905-46.32381 85.333334 0 146.285714 2.438095 292.571429 0 441.295238 0 46.32381 43.885714 95.085714 90.209524 97.523809 2.438095 0 153.6 2.438095 153.6 2.438095 51.2 0 70.704762-24.380952 75.580953-29.257142 2.438095-2.438095 9.752381-12.190476 24.380952-24.380953l73.142857-75.580952H355.961905c-17.066667 0-29.257143-9.752381-36.571429-24.380953-14.628571-29.257143 7.314286-60.952381 41.447619-60.952381h253.561905c17.066667 0 31.695238 0 43.885714 14.628572 12.190476 12.190476 14.628571 26.819048 12.190476 36.571428 0 0 0 4.87619-2.438095 12.190477l75.580953-80.457143c4.87619-4.87619 9.752381-14.628571 9.752381-24.380953-2.438095-63.390476-2.438095-126.780952-4.876191-192.609523z m-131.657143 153.6H358.4c-29.257143 0-46.32381-17.066667-46.32381-41.447619 0-26.819048 19.504762-43.885714 46.32381-43.885715h258.438095c29.257143 0 48.761905 19.504762 48.761905 43.885715s-19.504762 41.447619-48.761905 41.447619z"
        fill="#FFFFFF"
        p-id="45153"
      ></path>
      <path
        d="M748.495238 385.219048v-17.066667h-92.647619c-31.695238 0-53.638095-14.628571-65.828571-43.885714-4.87619-14.628571-7.314286-31.695238-9.752381-48.761905-2.438095-24.380952 0-51.2 0-78.019048H304.761905c-9.752381 0-21.942857 4.87619-29.257143 9.752381-31.695238 19.504762-48.761905 48.761905-48.761905 85.333334 0 146.285714 2.438095 292.571429 0 441.295238 0 21.942857 9.752381 43.885714 24.380953 60.952381 14.628571 2.438095 31.695238 2.438095 46.323809 2.438095 104.838095 0 216.990476-34.133333 295.009524-92.647619h-241.371429c-17.066667 0-29.257143-9.752381-36.571428-24.380953-14.628571-29.257143 7.314286-60.952381 41.447619-60.952381H609.52381c17.066667 0 31.695238 0 43.885714 14.628572 2.438095 2.438095 4.87619 7.314286 7.314286 9.752381 39.009524-43.885714 68.266667-95.085714 87.771428-148.72381 2.438095-36.571429 2.438095-73.142857 0-109.714285z m-131.657143 153.6H358.4c-29.257143 0-46.32381-17.066667-46.32381-41.447619 0-26.819048 19.504762-43.885714 46.32381-43.885715h258.438095c29.257143 0 48.761905 19.504762 48.761905 43.885715s-19.504762 41.447619-48.761905 41.447619z"
        fill="#FFFFFF"
        p-id="45154"
      ></path>
      <path
        d="M472.990476 538.819048h-114.590476c-29.257143 0-46.32381-17.066667-46.32381-41.447619 0-26.819048 19.504762-43.885714 46.32381-43.885715h197.485714c21.942857-29.257143 41.447619-60.952381 56.076191-95.085714-9.752381-7.314286-17.066667-17.066667-21.942857-31.695238-4.87619-14.628571-7.314286-31.695238-9.752381-46.32381-2.438095-24.380952 0-51.2 0-78.019047H304.761905c-9.752381 0-21.942857 4.87619-29.257143 9.752381-31.695238 19.504762-48.761905 48.761905-48.761905 85.333333V633.904762c87.771429-9.752381 182.857143-43.885714 246.247619-95.085714z m151.161905-338.895238v87.771428c0 7.314286 2.438095 14.628571 7.314286 21.942857 9.752381-31.695238 14.628571-65.828571 17.066666-97.523809-4.87619-7.314286-14.628571-9.752381-24.380952-12.190476z"
        fill="#FFFFFF"
        p-id="45155"
      ></path>
      <path
        d="M494.933333 202.361905h-187.733333c-9.752381 0-21.942857 4.87619-29.257143 9.752381-31.695238 19.504762-48.761905 48.761905-48.761905 85.333333v143.847619c109.714286-43.885714 216.990476-131.657143 265.752381-238.933333z"
        fill="#FFFFFF"
        p-id="45156"
      ></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: "SvgComponent",
  props: {
    iconName: {
      type: String,
      default: "index",
    },
    size: {
      type: String,
      default: "",
    },
  },
  computed: {
    svgStyle() {
      if (this.size === "" || this.size === undefined || this.size === null) {
        return {};
      }
      if (typeof this.size === "number") {
        return {
          width: `${this.size}px`,
          height: `${this.size}px`,
        };
      } else {
        // 假设字符串已经带单位，如'20px'、'2em'、'1rem'等
        return {
          width: this.size,
          height: this.size,
        };
      }
    },
  },
};
</script>

<style scoped>
div {
  display: flex;
  align-items: center;
  justify-content: center;
}

svg {
  /* 基础样式 */
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor; /* 关键：继承父元素颜色 */
  overflow: hidden;
}
</style>
